import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {
    ObjectBaseComponent
} from "../../../../../../core/shared/object/mvs-object-base/object-base.component";
import {NavigationItem} from "../../../../../../core/shared/dto/navigation/navigation-item";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../../core/shared/service/message/mvs-message.service";
import {ConfirmationService} from "primeng/api";
import {ObserverService} from "../../../../../../core/shared/object/service/observer.service";
import {EiImportTypeDto} from "../../../../model/dto/entity/ei-import-type.dto";


@Component({
    selector: 'ei-import-type-component',
    templateUrl: 'ei-import-type.component.html',
    standalone: false
})
export class EiImportTypeComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    dto: EiImportTypeDto;

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected override observerService: ObserverService,
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    onObjectChanged() {
        this.setPageTitle(this.dto?.name);
    }

    /**
     * Bubble navigation items up from the full view to the page shell (CONFIG-020).
     */
    handleNavigationItems(navigationItems: NavigationItem[]): void {
        this.onNavigationItems.emit(navigationItems);
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}
